import { render, staticRenderFns } from "./SISEC.vue?vue&type=template&id=31d12206&"
import script from "./SISEC.vue?vue&type=script&lang=js&"
export * from "./SISEC.vue?vue&type=script&lang=js&"
import style0 from "./SISEC.vue?vue&type=style&index=0&id=31d12206&prod&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports